<h3 style=" margin-left:10px;">{{'SCHEDULE.NEW_EVENT' | translate }}</h3>
<form [formGroup]="addEventForm" (ngSubmit)="save()">
  <mat-dialog-content style="font-family: Roboto;">


    <input name="EventId" type="hidden" formControlName="EventId" />

    <mat-form-field class="example-full-width">
      <input matInput placeholder="{{'SCHEDULE.TITLE' | translate }}" formControlName="Title" />
    </mat-form-field>
    <br />
    <mat-form-field style="width: 100%;">
      <textarea matInput placeholder="{{'SCHEDULE.COMMENT' | translate }}" formControlName="Comment" cdkAutosizeMinRows="3"
      cdkAutosizeMaxRows="10"></textarea>
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>{{'SCHEDULE.CHOOSE_DATE' | translate }}</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="EventDate">
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    &nbsp;
    <mat-form-field>
      <mat-label>{{'SCHEDULE.START_TIME' | translate }}</mat-label>
      <input matInput type="time" placeholder="{{'SCHEDULE.START_TIME' | translate }}" formControlName="EventTime" />
      <mat-hint>{{'SCHEDULE.TIMEZONE' | translate }}:{{this.displayTimeZone}}</mat-hint>
    </mat-form-field>&nbsp;
    <br />
    <mat-form-field>
      <mat-label>{{'SCHEDULE.CHOOSE_END_DATE' | translate }}</mat-label>
      <input matInput [matDatepicker]="pickerEnd" formControlName="EventEndDate">
      <mat-hint>YYYY-MM-DD</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
      <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>
    &nbsp;
    <mat-form-field>
      <mat-label>{{'SCHEDULE.END_TIME' | translate }}</mat-label>
      <input matInput type="time" placeholder="{{'SCHEDULE.END_TIME' | translate }}" formControlName="EventEndTime" />
      <mat-hint>{{'SCHEDULE.TIMEZONE' | translate }}:{{this.displayTimeZone}}</mat-hint>
    </mat-form-field>&nbsp;
    <br />
    <mat-checkbox formControlName="_PRIVATE">{{'SCHEDULE.PRIVATE' | translate }}</mat-checkbox>
  </mat-dialog-content>
  <mat-dialog-actions>
    @if ((isUpdate && this.theEvent.IsMyEvent) || !this.isUpdate) {
      <button mat-button type="submit"
      [disabled]="!this.addEventForm.valid">{{ 'GENERAL.SAVE' | translate | uppercase }}</button>
    }
    <button mat-button [mat-dialog-close]="false">{{ 'GENERAL.CLOSE' | translate | uppercase }}</button>
  </mat-dialog-actions>
</form>